/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PoliceRoleEntity } from './policeRoleEntity';
import { Login } from './login';
import { UpdatePartner } from './updatePartner';


export interface Partner { 
    partnertyp: Partner.PartnertypEnum;
    portalSprache: Partner.PortalSpracheEnum;
    korrespondenzSprache: Partner.KorrespondenzSpracheEnum;
    geschlecht: Partner.GeschlechtEnum;
    gwgBesondereAbklaerungen?: Partner.GwgBesondereAbklaerungenEnum;
    gwgRisiko?: Partner.GwgRisikoEnum;
    aufenthaltsbewilligung: Partner.AufenthaltsbewilligungEnum;
    zivilstand: Partner.ZivilstandEnum;
    datenAktualisierung: Partner.DatenAktualisierungEnum;
    partnernummer: string;
    azureB2cSub: string;
    swissidSub: string;
    vorname: string;
    nachname: string;
    organisationsName?: string;
    mobile: string;
    telefon: string;
    email: string;
    emailVerified: boolean;
    geburtsdatum: string;
    nationalitaet: string;
    adresseLand: string;
    adressePostleitzahl: string;
    adresseOrt: string;
    adresseStrasse: string;
    adresseHausnummer: string;
    adressePostfach: string;
    adresseZusatz: string;
    adresseCo: string;
    adresseGueltigab: string;
    beruf: string;
    erwerbsart: string;
    benachrichtigungenEmail: boolean;
    benachrichtigungenSms: boolean;
    benachrichtigungenPost: boolean;
    portalEligible: boolean;
    portalActive: boolean;
    lastSynchronized: string;
    changedescription: UpdatePartner;
    firstLogin: boolean;
    logins: Array<Login>;
    identificationCode: string;
    identificationCodeTTL: string;
    aktualisierungDate: string;
    sozialversicherungsnummer: string;
    policeRolesEntity: Array<PoliceRoleEntity>;
}
export namespace Partner {
    export type PartnertypEnum = '1' | '2' | '3';
    export const PartnertypEnum = {
        _1: '1' as PartnertypEnum,
        _2: '2' as PartnertypEnum,
        _3: '3' as PartnertypEnum
    };
    export type PortalSpracheEnum = 'DE' | 'FR' | 'IT';
    export const PortalSpracheEnum = {
        DE: 'DE' as PortalSpracheEnum,
        FR: 'FR' as PortalSpracheEnum,
        IT: 'IT' as PortalSpracheEnum
    };
    export type KorrespondenzSpracheEnum = 'DE' | 'FR' | 'IT' | 'EN';
    export const KorrespondenzSpracheEnum = {
        DE: 'DE' as KorrespondenzSpracheEnum,
        FR: 'FR' as KorrespondenzSpracheEnum,
        IT: 'IT' as KorrespondenzSpracheEnum,
        EN: 'EN' as KorrespondenzSpracheEnum
    };
    export type GeschlechtEnum = '0' | '1' | '2';
    export const GeschlechtEnum = {
        _0: '0' as GeschlechtEnum,
        _1: '1' as GeschlechtEnum,
        _2: '2' as GeschlechtEnum
    };
    export type GwgBesondereAbklaerungenEnum = 'keine_angabe' | 'besondere_abklaerungen_erfolgt' | 'besondere_abklaerungen_in_arbeit' | 'nicht_notwendig';
    export const GwgBesondereAbklaerungenEnum = {
        KEINE_ANGABE: 'keine_angabe' as GwgBesondereAbklaerungenEnum,
        BESONDERE_ABKLAERUNGEN_ERFOLGT: 'besondere_abklaerungen_erfolgt' as GwgBesondereAbklaerungenEnum,
        BESONDERE_ABKLAERUNGEN_IN_ARBEIT: 'besondere_abklaerungen_in_arbeit' as GwgBesondereAbklaerungenEnum,
        NICHT_NOTWENDIG: 'nicht_notwendig' as GwgBesondereAbklaerungenEnum
    };
    export type GwgRisikoEnum = 'tiefes_geldwaeschereirisiko' | 'mittleres_geldwaeschereirisiko' | 'erhoehtes_geldwaeschereirisiko' | 'keine_angabe' | 'kein_erhoehtes_geldwaeschereirisiko';
    export const GwgRisikoEnum = {
        TIEFES_GELDWAESCHEREIRISIKO: 'tiefes_geldwaeschereirisiko' as GwgRisikoEnum,
        MITTLERES_GELDWAESCHEREIRISIKO: 'mittleres_geldwaeschereirisiko' as GwgRisikoEnum,
        ERHOEHTES_GELDWAESCHEREIRISIKO: 'erhoehtes_geldwaeschereirisiko' as GwgRisikoEnum,
        KEINE_ANGABE: 'keine_angabe' as GwgRisikoEnum,
        KEIN_ERHOEHTES_GELDWAESCHEREIRISIKO: 'kein_erhoehtes_geldwaeschereirisiko' as GwgRisikoEnum
    };
    export type AufenthaltsbewilligungEnum = '' | '9' | 'A' | 'B' | 'C' | 'E' | 'F' | 'G' | 'L' | 'N';
    export const AufenthaltsbewilligungEnum = {
        EMPTY: '' as AufenthaltsbewilligungEnum,
        _9: '9' as AufenthaltsbewilligungEnum,
        A: 'A' as AufenthaltsbewilligungEnum,
        B: 'B' as AufenthaltsbewilligungEnum,
        C: 'C' as AufenthaltsbewilligungEnum,
        E: 'E' as AufenthaltsbewilligungEnum,
        F: 'F' as AufenthaltsbewilligungEnum,
        G: 'G' as AufenthaltsbewilligungEnum,
        L: 'L' as AufenthaltsbewilligungEnum,
        N: 'N' as AufenthaltsbewilligungEnum
    };
    export type ZivilstandEnum = '1' | '2' | '3' | '4' | '6' | '8' | '9';
    export const ZivilstandEnum = {
        _1: '1' as ZivilstandEnum,
        _2: '2' as ZivilstandEnum,
        _3: '3' as ZivilstandEnum,
        _4: '4' as ZivilstandEnum,
        _6: '6' as ZivilstandEnum,
        _8: '8' as ZivilstandEnum,
        _9: '9' as ZivilstandEnum
    };
    export type DatenAktualisierungEnum = 'Keine Angabe' | 'Ausstehend' | '1. Erinnerung' | '2. Erinnerung' | 'Erfolgt' | 'Nicht erfolgt' | 'Abgesendet';
    export const DatenAktualisierungEnum = {
        KEINE_ANGABE: 'Keine Angabe' as DatenAktualisierungEnum,
        AUSSTEHEND: 'Ausstehend' as DatenAktualisierungEnum,
        _1__ERINNERUNG: '1. Erinnerung' as DatenAktualisierungEnum,
        _2__ERINNERUNG: '2. Erinnerung' as DatenAktualisierungEnum,
        ERFOLGT: 'Erfolgt' as DatenAktualisierungEnum,
        NICHT_ERFOLGT: 'Nicht erfolgt' as DatenAktualisierungEnum,
        ABGESENDET: 'Abgesendet' as DatenAktualisierungEnum
    };
}


